"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-4a7a6e5b"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "TUI-conversation" };
var _hoisted_2 = {
    key: 0,
    class: "network"
};
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("i", { class: "icon icon-error" }, "!", -1); });
var _hoisted_4 = { class: "TUI-conversation-list" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_TUIConversationList = vue_1.resolveComponent("TUIConversationList");
    var _directive_loading = vue_1.resolveDirective("loading");
    return (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
        (_ctx.isNetwork)
            ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                vue_1.createElementVNode("p", null, "️" + vue_1.toDisplayString(_ctx.$t("TUIConversation.网络异常，请您检查网络设置")), 1)
            ]))
            : vue_1.createCommentVNode("", true),
        vue_1.withDirectives((vue_1.openBlock(), vue_1.createElementBlock("main", _hoisted_4, [
            vue_1.createVNode(_component_TUIConversationList, {
                currentID: _ctx.currentConversationID,
                data: _ctx.conversationData,
                onHandleItem: _ctx.handleCurrentConversation,
                isH5: _ctx.env.isH5,
                loading: _ctx.loading,
                displayOnlineStatus: _ctx.displayOnlineStatus,
                userStatusList: _ctx.userStatusList
            }, null, 8, ["currentID", "data", "onHandleItem", "isH5", "loading", "displayOnlineStatus", "userStatusList"])
        ])), [
            [
                _directive_loading,
                _ctx.loading,
                void 0,
                {
                    fullscreen: true,
                    lock: true
                }
            ]
        ])
    ]));
}
exports.render = render;
